import axiosInstance from "src/Funcs/axiosFuncs/axiosInstance";
import { API } from "src/Funcs/APIFuncs/APIFunc";

/**
 * Upsert current browser FCM token for the logged-in user.
 * Auth headers are added by axiosInstance interceptor.
 */
export async function upsertUserFcmToken(token, extra = {}) {
  if (!token) throw new Error("FCM token is required");

  const url = `${API}user/UpsertFcmToken`;
  const body = {
    token,
    provider: "fcm",
    platform: "web",
    userAgent:
      typeof navigator !== "undefined" ? navigator.userAgent : undefined,
    language: typeof navigator !== "undefined" ? navigator.language : undefined,
  };

  const { data } = await axiosInstance.post(url, body);
  return data;
}

/**
 * Delete/disassociate an FCM token for the logged-in user.
 */
export async function deleteUserFcmToken(token) {
  const url = `${API}user/DeleteFcmToken`;
  const body = token ? { token, platform: "web" } : { platform: "web" };
  const { data } = await axiosInstance.post(url, body);
  return data;
}
